export default {"src":"https://webcdn.trailways.com/_next/static/media/circle-info-brand.79ea657c.svg","height":27,"width":26,"blurWidth":0,"blurHeight":0};